{
  "notes": "Notes",
  "notes-empty": "Add notes.",
  "notes-latest": "Notes (Latest)",
  "edit-and-view-history": "Edit and View History",
  "immediate-family": "Immediate Family",
  "immediate-family-empty": "Add immediate family",
  "family-age": ", Age {{age}}",
  "family-age-months": ", Age {{age}} Months",
  "net-worth-progress": "Net Worth Progress",
  "annual-spending": "Annual Spending*",
  "personal-financial-statement": "Personal Financial Statement",
  "quarterly-progress-report": "Progress Report",
  "total-assets": "Total Assets",
  "total-debts": "Total Debts",
  "remove-app-access": "Remove App Access",
  "invitation-sent": "Invitation sent {{when}}",
  "mark-onboarding-as-completed": "Mark Onboarding as Completed",
  "onboarding-banner-body": "We’ll hold off on calculating progress in reports until you let us know {{- name}} {{isAre}} fully onboarded.",
  "remove-access-modal-ok": "Remove Access",
  "remove-access-modal-title": "Remove Client Access to Elements?",
  "remove-access-modal-body": "By removing client access to Elements they will no longer be able to access the Elements app.",
  "resend-invitation-body": "Verify the email addresses below and resend the invitation to {{- who}} to join you on Elements.",
  "important-people": "Important People",
  "other-relationship": "Other Relationships",
  "create-one-page-plan": "Create One-Page Plan",
  "one-page-plan-banner-text": "Don't forget—creating a One Page Plan for your client is a great way to help them stay focused and make progress.",
  "edit-financial-purpose-meta-title": "Edit the client's financial purpose",
  "edit-financial-purpose-heading": "Edit Financial Purpose",
  "edit-financial-purpose-placeholder": "Add your client’s financial purpose here...",
  "edit-goals-heading": "Edit Goals",
  "edit-goals-meta-title": "Create, edit, and delete financial goals for this client",
  "client-goals-empty": "Add client goals.",
  "client-next-steps-empty": "Add tasks.",
  "edit-next-steps-meta-title": "Create, edit, and delete tasks for this client",
  "edit-next-steps-heading": "Edit Tasks",
  "add-individual": "Add Individual",
  "edit-individual": "Edit Individual",
  "remove-individual-modal-title": "Remove Individual?",
  "remove-individual-modal-body": "Removing this person will delete them from your client’s profile and they will lose their access to the Elements app. Additionally, any assets or debts assigned to them will revert their ownership back to the primary head-of-household. This action cannot be undone.",
  "remove-individual-modal-ok": "Remove Individual",
  "prospect-banner-body_one": "{{- name}} is a prospect. Convert this prospect to a client to move them to your “Onboarding Group”",
  "prospect-banner-body_other": "{{- name}} are prospects. Convert them to a client to move them to your “Onboarding Group”.",
  "include-debt-payments": "*include debt payments",
  "remove-client": "Delete Client",
  "remove-client-modal-title": "Delete Client?",
  "remove-client-modal-body": "Deleting a client permanently removes them from your client lists, removes their app access, and disconnects their linked accounts. You will not be able to find or restore them. To keep their history and restore them later, archive the client instead.",
  "remove-client-notification": "You have deleted {{- user}} from your client list.",
  "archive-client": "Archive Client",
  "archive-client-modal-title": "Archive Client?",
  "archive-client-modal-body": "Archiving moves this client to your Archived list and out of your working lists. It removes their app access, disconnects their linked accounts, and removes them from their client group. Their history is kept, and you can unarchive them at any time, but app access, linked accounts, and group membership are not restored.",
  "archive-client-notification": "{{- user}} has been archived.",
  "unarchive-client": "Unarchive Client",
  "unarchive-client-modal-title": "Unarchive Client?",
  "unarchive-client-modal-body": "Unarchiving moves this client back to the list they were in before they were archived. App access, linked accounts, and client group membership are not restored: re-invite the client and have them reconnect their accounts.",
  "unarchive-client-invite-modal-title": "Unarchive Before Inviting",
  "unarchive-client-invite-modal-body": "This client is archived, so they can't be invited. Unarchive them first, then send the invitation. Their linked accounts and client group membership are not restored.",
  "unarchive-client-notification": "{{- user}} has been unarchived.",
  "archived-banner-body": "{{- name}} is archived. Archived clients have no app access or linked accounts and are hidden from your working lists.",
  "decayed-percentage": "{{- percentage}}% of balances are decayed",
  "client-page-household-income-button-label": "Household Income",
  "client-page-annual-spending-button-label": "Annual Spending",
  "client-page-scorecard-button-no-report": "Report unavailable",
  "client-page-scorecard-full-screen-button": "Full Screen",
  "client-details-tab-overview": "Overview",
  "client-details-tab-accounts": "Accounts",
  "client-details-tab-tasks-goals": "Tasks & Goals",
  "client-details-tab-documents-estate": "Documents",
  "client-details-download-progress-report": "Download Progress Report",
  "client-details-download-pfs-report": "Download Personal Financial Statement",
  "client-details-open-one-page-plan": "Open One-Page Plan",
  "client-details-documents-heading": "Documents",
  "client-details-documents-client-uploads-heading": "Client Uploads",
  "client-details-documents-uploaded-heading": "Uploaded Documents",
  "client-details-upload-document": "Upload Document",
  "client-details-documents-search-placeholder": "Search document titles",
  "client-details-documents-search-empty": "No documents match this search.",
  "client-details-documents-empty": "No uploaded documents yet.",
  "client-details-document-delete-success": "“{{- fileName}}” was deleted.",
  "client-details-documents-loading": "Loading documents...",
  "client-details-documents-error": "Documents could not be loaded.",
  "client-details-documents-retry": "Retry",
  "client-details-documents-unavailable": "Documents are not enabled.",
  "client-details-documents-source-client-upload": "Client Upload",
  "client-details-documents-source-general": "General",
  "client-details-documents-more-sources": "+{{count}} more",
  "client-details-documents-show-unlinked": "Show unlinked documents ({{count}})",
  "client-details-documents-select-all": "Select all",
  "client-details-documents-select-file": "Select “{{- fileName}}”",
  "client-details-documents-bulk-actions-label": "Bulk document actions",
  "client-details-documents-selected-count": "{{count}} selected",
  "client-details-documents-download-selected": "Download selected",
  "client-details-documents-delete-selected": "Delete selected",
  "client-details-documents-clear-selection": "Clear selection",
  "client-details-documents-archive-filename": "documents.zip",
  "client-details-documents-bulk-download-error": "The selected documents could not be downloaded. Please try again.",
  "client-details-documents-bulk-delete-title_one": "Delete {{count}} selected document?",
  "client-details-documents-bulk-delete-title_other": "Delete {{count}} selected documents?",
  "client-details-documents-bulk-delete-body_one": "This permanently deletes the selected document. This can’t be undone.",
  "client-details-documents-bulk-delete-body_other": "This permanently deletes the {{count}} selected documents. This can’t be undone.",
  "client-details-documents-bulk-delete-confirm": "Delete",
  "client-details-documents-bulk-delete-success_one": "Deleted {{count}} document.",
  "client-details-documents-bulk-delete-success_other": "Deleted {{count}} documents.",
  "client-details-documents-bulk-delete-partial": "{{count}} deleted, {{failedCount}} couldn’t be deleted.",
  "client-details-documents-source-accounts": "Accounts",
  "client-details-documents-source-business": "Business",
  "client-details-documents-source-real-estate": "Real Estate",
  "client-details-documents-source-notes": "Notes",
  "client-details-documents-source-property": "Property",
  "client-details-documents-source-debts": "Debts",
  "household-elements-customization-link-label": "Customize Elements",
  "household-elements-customization-description": "Choose which Elements are visible for this household.",
  "household-elements-customization-disabled-message": "Customize Elements is not enabled for this firm yet.",
  "household-elements-customization-firm-setting": "Firm setting",
  "household-elements-customization-show": "Show",
  "household-elements-customization-hide": "Hide",
  "household-elements-customization-visible-by-firm": "Visible by firm setting",
  "household-elements-customization-hidden-by-firm": "Hidden by firm setting",
  "household-elements-customization-shown-by-household": "Shown for this household",
  "household-elements-customization-hidden-by-household": "Hidden for this household",
  "household-element-customization-save-success": "Household Element visibility updated.",
  "household-element-customization-save-error": "Unable to update household Element visibility.",
  "income-page-heading": "Income & Spending",
  "income-page-description": "Manage household income sources and spending estimates here.",
  "income-page-empty-description": "Add your household income sources to estimate the amount you expect to earn during the current year.",
  "income-page-segmented-control-income": "Income Sources",
  "income-page-segmented-control-spending": "Spending",
  "income-page-add-income-source-button": "Add Income Source",
  "income-page-total-income-row-title": "Total Household Income",
  "spending-page-description": "Make sure to include all debt payments (currently {{- debtPaymentsDisplay}} {{- frequencySuffix}}) in this estimate.  We'll back out the Debt Payments from Burn Rate so they don't get double counted with Debt Rate too.",
  "spending-page-form-spending-amount-input-label": "Estimated Spending",
  "report-preview-page-action-button": "Download Report",
  "report-preview-page-report-name": "{{- givenName}} {{- familyName}}'s {{reportTypeDisplay}} ({{dateDisplay}})",
  "report-preview-error-page-modal-title": "Hmmmm...",
  "report-preview-error-page-modal-body": "Looks like we’re having trouble loading that report right now. Try again later. If this is happening to you frequently, contact us to help get to the bottom of this error.",
  "report-preview-error-page-modal-primary-action": "Contact Us",
  "download-element-report": "Download {{element}} Report",
  "estate-status-report-name": "Estate Status Report",
  "download-report": "Download Report",
  "add-to-client-group": "Add to Group...",
  "remove-all-custom-groups": "Remove from All",
  "client-groups-move-to-group": "{{- name}} moved to \"{{- group}}\"",
  "client-groups-removed-from-group": "{{- name}} removed from \"{{- group}}\"",
  "ai-assessment": {
    "invite-link": {
      "toggle-disclaimer": {
        "on": "Clients who onboard with this link will automatically be directed to an AI generated assessment at the end of onboarding.",
        "off": "Clients who onboard with this link will be directed to their Elements Scorecard or their custom assessment, if present, after onboarding."
      }
    },
    "client-options": {
      "toggle-disclaimer": {
        "on": "This client will be able to access and regenerate an AI assessment on their own",
        "off": "This client can only access assessments that have been manually edited and published by their advisor"
      }
    }
  },
  "intake-responses": "Intake Responses",
  "intake-responses-submitted": "Submitted {{date}}",
  "intake-responses-history_one": "1 earlier submission",
  "intake-responses-history_other": "{{count}} earlier submissions"
}